import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import useTokenExpiryHandler from "../services/useTokenExpiryHandler";
import SessionManager from "../auth/sessionmanager";
import PrivateComponent from "../PrivateComponent";
import Login from "../auth/Login";
import Home from "../views/Home";
import NotFound from "../views/NotFound";
import Requesthistory from "../views/Request_history";
import IntermodalWizard from "../views/wizard/IntermodalWizard";
import SolverMarketplace from "../views/SolverMarketplace";
import SolvingProcessesMarketplace from "../views/SolvingProcessesMarketplace";
import IframeComponent from "../views/IframeComponent";
import WizardSolvingProcesses from "../views/wizard/WizardSolvingProcesses";
import Results from "../views/Results";
import RouteMap from "../views/wizard/RouteMap";
import CreateNewEndpoints from "../views/CreateNewEndpoints";
import SolverIframe from "../views/SolverIframe";
import OnboardingSolvingProcesses from "../views/OnboardingSolvingProcesses";

function MyRoutes() {
  const location = useLocation();
  const [token, setToken] = useState(SessionManager.getToken());

  // Monitor token expiration
  useTokenExpiryHandler(token);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedToken = SessionManager.getToken();
      setToken(updatedToken);
    };

    window.addEventListener("storage", handleStorageChange); 

    return () => {
      window.removeEventListener("storage", handleStorageChange);     
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<PrivateComponent><Home /></PrivateComponent>} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<PrivateComponent><Home /></PrivateComponent>} />
      <Route path="/Requesthistory" element={<PrivateComponent><Requesthistory /></PrivateComponent>} />      
      <Route path="/IntermodalWizard" element={<PrivateComponent><IntermodalWizard /></PrivateComponent>} />
      <Route path="/Solver_Marketplace" element={<PrivateComponent><SolverMarketplace /></PrivateComponent>} />
      <Route path="/SolvingProcesses_Marketplace" element={<PrivateComponent><SolvingProcessesMarketplace /></PrivateComponent>} />
      <Route path="/WorkflowEngine" element={<PrivateComponent><IframeComponent /></PrivateComponent>} />
      <Route path="/WizardSolvingProcesses" element={<PrivateComponent><WizardSolvingProcesses key={location.key} /></PrivateComponent>} />
      <Route path="/Results" element={<PrivateComponent><Results /></PrivateComponent>} />
      <Route path="/RouteMap" element={<PrivateComponent><RouteMap /></PrivateComponent>} />
      <Route path="/CreateNewEndpoints" element={<PrivateComponent><CreateNewEndpoints /></PrivateComponent>} />
      <Route path="/OnboardingSolvingProcesses" element={<PrivateComponent><OnboardingSolvingProcesses /></PrivateComponent>} />
      <Route path="/SolverIframe" element={<PrivateComponent><SolverIframe /></PrivateComponent>} />
      <Route path="*" element={<PrivateComponent><NotFound /></PrivateComponent>} />
    </Routes>
  );
}

export default MyRoutes;
